import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import Button from '@/shared/components/buttons/Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
    text: null,
    riskCategory: null,
    visible: { type: Boolean }
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:visible', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  text: string;
  riskCategory: string;
  visible: boolean;
}





const titleColorClass = computed(() => {
  switch (props.riskCategory) {
    case 'high':
      return 'modal-title-danger';
    case 'medium':
      return 'modal-title-warning';
    case 'low':
      return 'modal-title-primary';
    default:
      return 'modal-title-primary';
  }
});

function toggle() {
  emit('update:visible', !props.visible);
}

return { __sfc: true,emit, props, titleColorClass, toggle, Button }
}

})